import type { BrainBreakPlacement } from '../models/BrainBreak';

export const HASH_PLACEMENTS: BrainBreakPlacement[] = [
  'post-login',
  'about-the-skill',
  'worked-example',
  'practice-problems',
  'assessment-completed',
];

/** FNV-1a 32-bit hash — deterministic, good distribution, zero deps. */
function fnv1a32(str: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return Math.abs(hash | 0);
}

/** hash(userId + ":" + YYYY-MM-DD) % HASH_PLACEMENTS.length → one placement per user per day */
export function getAssignedPlacement(userId: string, calendarDate: string): BrainBreakPlacement {
  const key = `${userId}:${calendarDate}`;
  const index = fnv1a32(key) % HASH_PLACEMENTS.length;
  return HASH_PLACEMENTS[index];
}

/** `assessment-completed` matches both `_passed` and `_failed` variants. */
export function isAssignedPlacement(assigned: BrainBreakPlacement, requested: BrainBreakPlacement): boolean {
  if (assigned === requested) return true;
  if (assigned === 'assessment-completed') {
    return requested === 'assessment-completed_passed' || requested === 'assessment-completed_failed';
  }
  return false;
}
